import { Accordion, AccordionDetails, AccordionSummary, FormControlLabel, Switch, Typography } from '@mui/material';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useEffect, useState, } from 'react'
//import { MenuItem, Select } from '@mui/base';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { ColorPicker, ColorBox } from "material-ui-color";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { saveWebsiteResource, showSuccessToast, showErrorToast, getImageData, appendScriptToHeadOrBody, updateCssJsonWrtThemeId, showWarningToast, getLogoWidthAndHeight } from './Utils';
import "./GlobalSettingComponent.css"
import {
  DEFAULT_DISPLAY_DATE_FORMAT,
  DEFAULT_DISPLAY_TIME_ZONE,
  // Phase 2: re-enable when Date Format dropdown goes live.
  // DISPLAY_DATE_FORMAT_OPTIONS,
  DISPLAY_TIME_ZONE_OPTIONS,
  DEFAULT_SITE_FONT,
  SITE_FONT_FAMILIES,
  SITE_LANGUAGES,
} from './constants';

const getFontOptions = (language, themeId) => {
  const selectedLanguage = language && language !== 'Select' ? language : 'en';
  const languageFont = selectedLanguage === 'en'
    ? SITE_FONT_FAMILIES.en[String(themeId)]
    : SITE_FONT_FAMILIES[selectedLanguage];

  return languageFont ? [languageFont, DEFAULT_SITE_FONT] : [DEFAULT_SITE_FONT];
};

function GlobalSettingComponent(props) {

  const initialFontOptions = getFontOptions(props.siteResource?.siteLanguage, props.siteResource?.themeId);
  const initialSelectedFont = initialFontOptions.some((font) => font.value === props.siteResource?.userSelectedFontFamily)
    ? props.siteResource.userSelectedFontFamily
    : DEFAULT_SITE_FONT.value;

  const [themeJson, setThemeJson] = useState(props.themeJson || {});
  const [expanded, setExpanded] = useState([false, false, false, false, false, false, false, false]);
  const [socialPlatformLists, setSocialPlatformList] = useState(props.siteResource.socialPlatformList);
  const [clicked, setClicked] = useState(true);
  const [subexpandedAccordion, setSubExpandedAccordion] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [subexpandedTopNavAccordion, setSubExpandedTopNavAccordion] = useState(null);
  
  const whatsappLabel = "whatsapp";
  const facebookLabel = "facebook";
  const twitterLabel = "twitter";
  const youTubeLabel = "youtube";
  const linkedInLabel = "linkedIn";
  const instagramLabel = "instagram";
  const pinterestLabel = "pinterest";
  const playStoreLabel = "playstore";

  const [formData, setFormData] = useState({
    ...props.siteResource,
    userSelectedFontFamily: initialSelectedFont,
    displayTimeZone: props.siteResource?.displayTimeZone || DEFAULT_DISPLAY_TIME_ZONE,
    displayDateFormat: props.themeJson?.displayDateFormat || DEFAULT_DISPLAY_DATE_FORMAT,
  });


  const updateThemeJson = (newThemeJson) => {
    setThemeJson(newThemeJson);
  };

  const handleThemeConfigChange = (name, value) => {
    setThemeJson((prevThemeJson) => ({
      ...(prevThemeJson || {}),
      [name]: value,
    }));
    handleInputChange(name, value);
  };

  const handleChange = (panel) => (event, isExpanded) => {
    const chars = panel.split('');
    const lastDigit = chars[chars.length - 1];
    const value = isExpanded ? panel : false;
    setExpanded((prevState) => {
      const newState = [...prevState];
      newState[lastDigit - 1] = value;
      return newState;
    });
  };

  const handleColorInputChange = (name, colorResult) => {
    let hexColor = "";
    if (colorResult.css) {
      hexColor = colorResult.css.backgroundColor;
    }
    handleInputChange(name, hexColor);
  };

  const reorderWhatsappFirst = (list) => {
    const idx = list.findIndex(item => (item?.name || '').toLowerCase() === whatsappLabel);
    if (idx > 0) {
      const whatsappItem = list[idx];
      const rest = list.filter((_, i) => i !== idx);
      return [whatsappItem, ...rest];
    }
    return list;
  };

  const handleUrlChange = (name, newUrl) => {
    const index = socialPlatformLists.findIndex(platform => platform.name.toLowerCase() === name.toLowerCase());

    if (index !== -1) {
      const updatedPlatform = { ...socialPlatformLists[index], url: newUrl };
      const updatedList = [...socialPlatformLists];
      updatedList[index] = updatedPlatform;

      const orderedList = reorderWhatsappFirst(updatedList);
      setSocialPlatformList(orderedList);
      handleInputChange(name, newUrl);
      handleInputChange('socialPlatformList', orderedList);
    }
    else {
      const newPlatform = { name: name, url: newUrl };
      const newList = [...socialPlatformLists, newPlatform];

      const orderedList = reorderWhatsappFirst(newList);
      setSocialPlatformList(orderedList);
      handleInputChange(name, newUrl);
      handleInputChange('socialPlatformList', orderedList);
    }
  };

  // const handleInputChange = (name, value) => {
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [name]: (value),
  //   }));
  // };

  // const handleInputChange = (name, value) => {
  //     setFormData( (prevData) => {

  //       const keysForWebStory = ["webStoryAds", "ampHeaderScript", "adsSlots", "webstoryLogo" , "webstoryDefaultAuthor", "webstoryDefaultAgencyName","ctaDesc", "ctaBgColor","ctaBtnText","ctnBtnBgColor","ctaNextSlide","ctaNextSlideMsg"];
  //       const keysForImmersiveStory = ["immStoryGa4Id", "immStoryGaId", "immStoryLogoHeight"];
        
  //       //Checking for immersive story
  //       if(keysForImmersiveStory.includes(name)) {
  //         // setImmersivestoryFlag(true);
  //         // handleInputChange("updateFlagImmersiveStory", immersivestoryFlag);
  //         setFormData((prevData) => ({
  //           ...prevData,
  //           updateFlagImmersiveStory: true
  //         }));
  //       }

  //       if(keysForWebStory.includes(name)) {
  //         // setWebstoryFlag(true);
  //         // webstoryFlag = true;
  //         // handleInputChange("updateFlagWebStory", webstoryFlag);
  //         setFormData((prevData) => ({
  //           ...prevData,
  //           updateFlagWebStory: true
  //         }));
  //       }

  //       if (name == "webstoryLogo") {

  //         if(value != null && value != "") {
  //           const jsonResponse = getLogoWidthAndHeight(value);
  
  //           if (jsonResponse != undefined && jsonResponse != null && jsonResponse.originalImageHeightPx != null && jsonResponse.originalImageWidthPx != null) {
  
  //             setFormData((prevData) => ({
  //               ...prevData,
  //               webstoryLogoWidth: jsonResponse.originalImageWidthPx,
  //               webstoryLogoHeight: jsonResponse.originalImageHeightPx
  //             }));
  //           }
  //         }
  //       }
        
  //       console.log("formdata" , formData);

  //       return {
  //         ...prevData,
  //         [name]: value,
  //       };
  //     })
  // }

  const handleInputChange = (name, value) => {
    setFormData((prevData) => {
      const keysForWebStory = ["webStoryAds", "ampHeaderScript", "adsSlots", "webstoryLogo", "webstoryDefaultAuthor", "webstoryDefaultAgencyName", "ctaDesc", "ctaBgColor", "ctaBtnText", "ctnBtnBgColor", "ctaNextSlide", "ctaNextSlideMsg", "gaId", "ga4Id","webstoryCustomSlidePosition"];
      const keysForImmersiveStory = ["immStoryLogo", "immStoryGa4Id", "immStoryGaId", "immStoryLogoHeight","webstoryNextSlideCta"];

      let newData = { ...prevData, [name]: value };

      if (keysForImmersiveStory.includes(name)) {
        newData.updateFlagImmersiveStory = true;
      }

      if (keysForWebStory.includes(name)) {
        newData.updateFlagWebStory = true;
      }

      if (name === 'siteLanguage') {
        const isArabic = value === 'ar';
        const langVal = value && value !== 'Select' ? value : 'en';
        const dirVal = isArabic ? 'rtl' : 'ltr';
        const availableFonts = getFontOptions(langVal, prevData.themeId || props.siteResource?.themeId);
        if (newData.userSelectedFontFamily && !availableFonts.some((font) => font.value === newData.userSelectedFontFamily)) {
          newData.userSelectedFontFamily = DEFAULT_SITE_FONT.value;
        }

        if (typeof document !== 'undefined' && document.documentElement) {
          document.documentElement.lang = langVal;
          document.documentElement.dir = dirVal;
        }

        const iframe = document.querySelector('iframe.gjs-frame');
        if (iframe && iframe.contentDocument && iframe.contentDocument.documentElement) {
          iframe.contentDocument.documentElement.lang = langVal;
          iframe.contentDocument.documentElement.dir = dirVal;
        }
      }

      if (name === "hostImageId" && value) {
        const jsonResponse = getLogoWidthAndHeight(value);

        if (jsonResponse && jsonResponse.originalImageHeightPx && jsonResponse.originalImageWidthPx) {
          newData.hostImageSize = jsonResponse.originalImageWidthPx + "" + jsonResponse.originalImageHeightPx;
        } else {
          showErrorToast("Please provide valid Default Image.  Either Image is Corrupt or MSID is not correct");
        }
      }

      if (name === "webstoryLogo" && value) {
        const jsonResponse = getLogoWidthAndHeight(value);

        if (jsonResponse && jsonResponse.originalImageHeightPx && jsonResponse.originalImageWidthPx && (jsonResponse.originalImageHeightPx != "null" || jsonResponse.originalImageWidthPx != "null")) {
          newData.webstoryLogoWidth = jsonResponse.originalImageWidthPx;
          newData.webstoryLogoHeight = jsonResponse.originalImageHeightPx;
        } else {
          showErrorToast("Please enter valid webstory Logo.  Either Logo Image is Corrupt or MSID is not correct");
        }
      }

      if (name === "immStoryLogo" && value) {
        const jsonResponse = getLogoWidthAndHeight(value);

        if (jsonResponse && jsonResponse.originalImageHeightPx && jsonResponse.originalImageWidthPx && (jsonResponse.originalImageHeightPx != "null" || jsonResponse.originalImageWidthPx != "null")) {
          newData.immStoryLogoHeight = jsonResponse.originalImageHeightPx
        }
        else {
          showErrorToast("Please enter valid Immersive Story Logo. Either Logo Image is Corrupt or MSID is not correct");
        }
      }

      if (name === "mainLogo" && value) {
        const jsonResponse = getLogoWidthAndHeight(value);

        if (jsonResponse && jsonResponse.originalImageHeightPx && jsonResponse.originalImageWidthPx) {
          newData.imageWidth = jsonResponse.originalImageWidthPx;
          newData.imageHeight = jsonResponse.originalImageHeightPx;
        }
      }
      return newData;
    });
  };

  const encodeHTML = (text) => {
    const element = document.createElement('div');
    element.innerText = text;
    return element.innerHTML;
  };

  const handleScriptChange = (name, value) => {
    let jsonObj = {}; 
    if(props.themeJson && props.themeJson != '') {
      jsonObj = props.themeJson;
    }
    
    if (name === "headerScript") {
      jsonObj.globalHeaderScript = value.trim();
      //appendScriptToHeadOrBody("header_script", value.trim());
      handleInputChange("headerScript", value);
    }
    if (name === "bodyScript") {
      jsonObj.globalBodyScript = value.trim();
      //appendScriptToHeadOrBody("body_script", value.trim());
      handleInputChange("bodyScript", value);
    }
    updateThemeJson(jsonObj);
  }
  const getUrlByName = (name) => {
    const entry = socialPlatformLists.find(item => item.name.toLowerCase().includes(name.toLowerCase()));
    return entry ? entry.url : '';
  };

  function isValidHTML(htmlString) {
    if (htmlString == "" || htmlString == null)
      return true;
    const validTagRegex = /<script\b[^>]*>([\s\S]*?)<\/script>/i;
    return validTagRegex.test(htmlString);
  }
  // function hasScriptAttributes(scriptString) {
  //   if (scriptString == "" || scriptString == null) {
  //     return true;
  //   }
  //   const attributesRegex = /\b(?:async|defer|type\s*=\s*["']\s*module\s*["'])\b/g;
  //   const matches = scriptString.match(attributesRegex) || [];
  //   return matches.includes('async') || matches.includes('defer') || matches.includes('type="module"');
  // }

  function hasScriptAttributes(scriptTagStr) {

    if (scriptTagStr == "" || scriptTagStr == null) {
      return true;
    }
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = scriptTagStr.trim();
    // const scriptTag = tempDiv.querySelector('script');

    let validScriptFlag = true;

    const scriptElements = tempDiv.querySelectorAll('script');

    for (const scriptTag of scriptElements) {
      if(scriptTag.hasAttribute('src')) {
        
        const hasAsync = scriptTag.hasAttribute('async');
        const hasDefer = scriptTag.hasAttribute('defer');
        const isModule = scriptTag.getAttribute('type') === 'module';
  
        if(hasAsync || hasDefer || isModule) {
          validScriptFlag = true;
        } else {
          validScriptFlag = false;
          break;
        }
      }
    }

    if(validScriptFlag) {
      return true;
    } else {
      return false;
    }
  } 

  function validateImg(type, msId) {
    if (msId == "" || msId == null)
      return true;

    let data = getImageData(msId);

    if (data && data.items.length > 0) {
      if (data.items[0] && data.items[0].tn == "IMAGES") {
        if (type === "schemaLogo" && data.items[0] && +data.items[0].imageHeight < 112 && +data.items[0].imageWidth < 112) {
          showErrorToast("Schema Logo should be more than 112*112px");
          return false;
        }
        return true;
      }
      else {
        switch(type) {
          case "immStoryLogo":
            showErrorToast("Please enter valid Immersive Story Logo Id");
            return false;
          case "webstoryLogo":
            showErrorToast("Please enter valid Webstory Logo Id");
            return false;
          default:
            showErrorToast("Please enter valid " + type + " Id");
            return false;
        }
      }
    } else {
        switch(type) {
          case "immStoryLogo":
            showErrorToast("Please enter valid Immersive Story Logo Id");
            return false;
          case "webstoryLogo":
            showErrorToast("Please enter valid Webstory Logo Id");
            return false;
          default:
            showErrorToast("Please enter valid " + type + " Id");
            return false;
        }
    }
  }

  function validateMsid(type, msId) {
    if (msId == "" || msId == null)
      return true;

    let data = getImageData(msId);
    if (!(data && data.items.length > 0)) {
      showErrorToast("Please enter valid msid in (" + type + ") static page");
      return false;
    }
    return true;
  }

  function isNumber(value) {
    return typeof value === 'number' && !isNaN(value);
  }
  async function handleButtonClick() {

    if (formData.ctaDesc == "" || formData.ctaDesc == null) {
      showErrorToast("Please enter CTA Description");
      return false;
    }
    if (formData.ctaBtnText == "" || formData.ctaBtnText == null) {
      showErrorToast("Please enter CTA Text");
      return false;
    }
    if (formData.websiteTitle == "" || formData.websiteTitle == null) {
      showErrorToast("Please enter Website Title");
      return false;
    }

    if (!isValidHTML(formData.headerScript)) {
      showErrorToast("Enter a valid Header Script");
      return false;
    }
    if (!isValidHTML(formData.bodyScript)) {
      showErrorToast("Enter a valid Body Script");
      return false;
    }
    if (!(formData.adsSlots) && formData.ampHeaderScript && formData.ampHeaderScript != "none") {
      showErrorToast("Enter a valid Data Slot ID.");
      return false;
    }
    if ((!(formData.ampHeaderScript) || formData.ampHeaderScript == "none") && formData.adsSlots) {
      showErrorToast("Enter a valid Webstory Ad Type");
      return false;
    }
    if (!hasScriptAttributes(formData.headerScript)) {
      showErrorToast("Header Script must include async, defer, type=\"module\"");
      return false;
    }
    if (!hasScriptAttributes(formData.bodyScript)) {
      showErrorToast("Body Script must include async, defer, type=\"module\"");
      return false;
    }
    // if (!hasScriptAttributes(formData.adsSlots)) {
    //   showErrorToast("Amp Body Script must include async, defer, type=\"module\"");
    //   return false;
    // }
    // if (!hasScriptAttributes(formData.ampHeaderScript)) {
    //   showErrorToast("Amp Header Script must include async, defer, type=\"module\"");
    //   return false;
    // }

    if (formData.mainLogo == null || formData.mainLogo == "") {
      showErrorToast("Please enter Main Logo");
      return false;
    }
    else if (!validateImg("mainLogo", formData.mainLogo)) {
      //  showErrorToast("Please enter valid Favicon Id");
      return false;
    }

    // if (formData.favicon == null || formData.favicon == "") {
    //   showErrorToast("Please enter Favicon");
    //   return false;
    // }
    // else if (!validateImg("favicon", formData.favicon)) {
    //   // showErrorToast("Please enter valid Logo Id");
    //   return false;
    // }
    if (!validateImg("fallbackImage", formData.fallbackImage)) {
      //showErrorToast("Please enter valid fallbackImage Id");
      return false;
    }
    if (formData.schemaLogo == null || formData.schemaLogo == "") {
      showErrorToast("Please enter Schema Logo");
      return false;
    }
    else if (!validateImg("schemaLogo", formData.schemaLogo)) {
      //showErrorToast("Please enter valid schemaLogo Id");
      return false;
    }
    if (formData.siteLanguage == null || formData.siteLanguage == "") {
      showErrorToast("Please enter Website Language");
      return false;
    }

    if(formData.webstoryLogo == null || formData.webstoryLogo == "") {
      showErrorToast("Please enter Webstory Logo");
      return false;
    
    } else if (!validateImg("webstoryLogo", formData.webstoryLogo)) {
      return false;
    }

    if(formData.webstoryDefaultAuthor == null || formData.webstoryDefaultAuthor == "") {
      showErrorToast("Please enter Webstory Default Author");
      return false;
    }

    if(formData.webstoryDefaultAgencyName == null || formData.webstoryDefaultAgencyName == "") {
      showErrorToast("Please enter Webstory Default Agency Name");
      return false;
    }

    if( !(formData.webstoryCustomSlidePosition== null || formData.webstoryCustomSlidePosition == "") && Number.isNaN(+formData.webstoryCustomSlidePosition)) {
      showErrorToast("Please enter valid Custom Slide Position. It should be number only");
      return false;
    }

    if(formData.immStoryLogo == null || formData.immStoryLogo == "" || formData.immStoryLogo == "null") {
      showErrorToast("Please enter Immersive Story Logo");
      return false;
    
    } else if (!validateImg("immStoryLogo", formData.immStoryLogo)) {
      return false;
    }

    if(formData.immStoryLogoHeight == null || formData.immStoryLogoHeight == "") {
      showErrorToast("Please enter Immersive Story Logo height");
      return false;
    }

    if(formData.aboutSiteContent != null && formData.aboutSiteContent != "" && formData.aboutSiteContent.length >= 200) {
      showErrorToast("About site content length should be less than 200 characters");
      return false;
    }

    if (formData.staticPages) {
      const staticPageError = formData?.staticPages.filter((item) => {
        // Basic validation for empty fields
        // if (item.name === '' || item.sourcePath === '' || item.destinationPath === '') {
        if (item.name === '' || item.sourcePath === '' || (item.destinationPath === '' && item.sourcePath.startsWith('/'))) {
          return true;
        }

        // For Absolute URL, destination path should not be blank for API so populate it with /staticpage/.html.
        if(item.destinationPath === '' && item.sourcePath.startsWith('https://')){
          item.destinationPath = "/staticpage/.html"; 
        }

        // For non-https URLs, destination path should not be /staticpage/.html. Not checking for https URLs.
        if (!item.sourcePath.startsWith('https://')) {
          return item.destinationPath === '/staticpage/.html';
        }
        // For https URLs, no specific destination path validation needed
        return false;
      });

      if (staticPageError.length > 0) {
        showErrorToast("Please enter valid details in static page.")
        return false;
      }

      // const staticPageSourcePath = formData?.staticPages.filter((item) => !item.sourcePath.startsWith('/'))
      // if (staticPageSourcePath.length > 0) {
        // console.log("staticPageSourcePath is relative URL :: ", staticPageSourcePath);
        // let errorString = `The Short Url doesn't start with '/' for `;
        // staticPageSourcePath.map((item,) => {
        //   errorString += `${item.name}, `;
        // })
        // const errorString1 = errorString.substring(0, errorString.length - 2);
        // showErrorToast(errorString1);
        // return false;
      // } else   {
      //   console.log("staticPageSourcePath is absolute URL :: ", staticPageSourcePath);
      // }

      const boolinan = checkForDuplicateSourcePath(formData?.staticPages);
      if (!boolinan) {
        return false;
      }
      
      const msidArray = formData?.staticPages.map(obj => {
        const match = obj.destinationPath.match(/\/staticpage\/(\d+)\.html/);
        return {
          msid: match ? match[1] : null,
          name: obj.name,
          sourcePath: obj.sourcePath
        };
      }).filter(item => {
        // Only flag items where msid is missing AND sourcePath doesn't start with https
        return item.msid === null && !item.sourcePath.startsWith('https://');
      });

      if (msidArray.length > 0) {
        // Create error message with only the names of pages missing msids
        const errorMessage = `Please enter valid msids in static pages for: ${msidArray.map(item => item.name).join(", ")}`;
        showErrorToast(errorMessage);
        return false;
      }

      // Validate msids for pages that have them
      const pagesWithMsids = formData?.staticPages
        .map(obj => {
          // Extract msid directly from destinationPath without regex
          const msid = obj.destinationPath.split('/staticpage/')[1]?.split('.html')[0] || null;
          return {
            msid,
            name: obj.name,
            sourcePath: obj.sourcePath
          };
        })
        // .filter(item => {
        //   // Only validate msids for non-https URLs and where msid exists
        //   return item.msid !== null && !item.sourcePath.startsWith('https://');
        // });

      // Only proceed with validation if we have pages that need msid validation
      if (pagesWithMsids.length > 0) {
        // Validate each msid individually to ensure we're using the latest values
        for (const page of pagesWithMsids) {
          const isValid = validateMsid(page.name, page.msid);
          if (!isValid) {
            return false;
          }
        }
      }
    }

    setClicked(true);
    try {
      setIsSaving(true);
      const resolvedDisplayTimeZone = formData.displayTimeZone || DEFAULT_DISPLAY_TIME_ZONE;
      const resolvedDisplayDateFormat = formData.displayDateFormat || DEFAULT_DISPLAY_DATE_FORMAT;
      const updatedThemeJson = {
        ...(themeJson || {}),
        displayDateFormat: resolvedDisplayDateFormat,
      };
      const normalizedFormDataToSend = {
        ...finalFormDataToSend,
        displayTimeZone: resolvedDisplayTimeZone,
        displayDateFormat: resolvedDisplayDateFormat,
      };
      updateThemeJson(updatedThemeJson);
      const responseee = await saveWebsiteResource(normalizedFormDataToSend);    
      await updateCssJsonWrtThemeId(1, updatedThemeJson, props.themeCss);
      await updateCssJsonWrtThemeId(2, updatedThemeJson, props.themeCss);
      
      if(responseee) {
        const updatedSiteResource = {
          ...responseee,
          userSelectedFontFamily: responseee.userSelectedFontFamily || normalizedFormDataToSend.userSelectedFontFamily,
          displayTimeZone: responseee.displayTimeZone || resolvedDisplayTimeZone,
          displayDateFormat: responseee.displayDateFormat || resolvedDisplayDateFormat,
        };
        sessionStorage.setItem('siteResources', JSON.stringify(updatedSiteResource));
        setFormData(updatedSiteResource);
      }
      
      showSuccessToast("Global Settings Saved Successfully");

      setFormData((prevData) => ({
        ...prevData,
        updateFlagImmersiveStory: false
      }));

      setFormData((prevData) => ({
        ...prevData,
        updateFlagWebStory: false
      }));

    } catch (e) {
      console.error('Call saveGLobalSettings failed with status: ' + e);
      showErrorToast("Some Went Wrong, Please try again later!");

    } finally {
      setIsSaving(false);
      setClicked(false);
    }
  }

  function checkForDuplicateSourcePath(errors) {
    const errorNames = new Set();
    const errorSource = new Set();

    for (const error of errors) {
      if (errorNames.has(error.name)) {
        showErrorToast(`Duplicate name found in static pages: ${error.name}`)
        return false;
      }
      if (errorSource.has(error.sourcePath)) {
        showErrorToast(`Duplicate source path found in static pages: ${error.sourcePath}`)
        return false;
      }
      errorNames.add(error.name);
      errorSource.add(error.sourcePath);
    }
    console.log("No duplication found in static pages.");
    return true;
  }

  // const handleNewline = (e) => {
  //   if (e.key === 'Enter') {
  //     e.preventDefault(); // Prevents the actual newline character from being inserted
  //     return e.target.value + '\n';
  //   } else {
  //     return e.target.value;
  //   }
  // };

  useEffect(() => {
    const selectedLang = formData?.siteLanguage;
    const isArabic = selectedLang === 'ar';

    // Sync document attributes (lang and dir) immediately when the site language is selected
    if (typeof document !== 'undefined' && document?.documentElement) {
      document.documentElement.lang = selectedLang || 'en';
      document.documentElement.dir = isArabic ? 'rtl' : 'ltr';
    }
  }, [formData?.siteLanguage]);

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      headerScript: props.themeJson?.globalHeaderScript,
      bodyScript: props.themeJson?.globalBodyScript,
      adNetwork: formData.adNetwork,
      paragraphOffset: formData.paragraphOffset,
      websiteTitle: formData.websiteTitle,
      tagline: formData.tagline,
      siteDescription: formData.siteDescription,
      mainLogo: formData.mainLogo,
      // favicon: formData.favicon,
      fallbackImage: formData.fallbackImage,
      schemaLogo: formData.schemaLogo,
      ampGaId: formData.ampGaId,
      ampGa4Id: formData.ampGa4Id,
      adsTxtFile: formData.adsTxtFile,
      robotsTxt: formData.robotsTxt,
      copyRightContent: formData.copyRightContent,
      siteLanguage: formData.siteLanguage,
      imageAgencyLabel: formData.imageAgencyLabel,
      displayDate: formData.displayDate,
      displayTimeZone: formData.displayTimeZone || DEFAULT_DISPLAY_TIME_ZONE,
      displayDateFormat: themeJson?.displayDateFormat || DEFAULT_DISPLAY_DATE_FORMAT,

      hostImageId: formData.hostImageId,
      hostImageSize: formData.hostImageSize,

      webstoryLogo: formData.webstoryLogo,
      webstoryLogoWidth: formData.webstoryLogoWidth,
      webstoryLogoHeight: formData.webstoryLogoHeight,
      webStoryAds: formData.webStoryAds,
      ampHeaderScript: formData.ampHeaderScript,
      adsSlots: formData.adsSlots,
      ctaDesc: formData.ctaDesc,
      ctaBtnText: formData.ctaBtnText,
      ctaBgColor: formData.ctaBgColor,
      ctnBtnBgColor: formData.ctnBtnBgColor,
      ctaNextSlide: formData.ctaNextSlide,
      socialPlatformList: socialPlatformLists,
      // imageHeight: formData.imageHeight,
      // imageWidth: formData.imageWidth,
      webstoryDefaultAuthor: formData.webstoryDefaultAuthor,
      webstoryDefaultAgencyName: formData.webstoryDefaultAgencyName,
      gaId: formData.gaId,
      ga4Id: formData.ga4Id,
      webstoryCustomSlidePosition: formData.webstoryCustomSlidePosition,
      webstoryNextSlideCta: formData.webstoryNextSlideCta,
      // updateFlagWebStory: false,

      immStoryLogo: formData.immStoryLogo,
      // immStoryLogoHeight: formData.immStoryLogoHeight,
      immStoryGaId: formData.immStoryGaId,
      immStoryGa4Id: formData.immStoryGa4Id,
      // updateFlagImmersiveStory: false,

      whatsapp: getUrlByName(whatsappLabel),
      facebook: getUrlByName(facebookLabel),
      twitter: getUrlByName(twitterLabel),
      youtube: getUrlByName(youTubeLabel),
      linkedIn: getUrlByName(linkedInLabel),
      instagram: getUrlByName(instagramLabel),
      pinterest: getUrlByName(pinterestLabel),
      playstore: getUrlByName(playStoreLabel)
    }));
  }, [clicked]);

  const { headerScript, bodyScript, whatsapp,facebook, twitter, youtube, linkedIn, instagram, pinterest, playstore, ...formDataToSend } = formData;
  const finalFormDataToSend = {
    ampHeaderScript: encodeHTML(formData.ampHeaderScript),
    adsSlots: encodeHTML(formData.adsSlots),
    websiteTitle: encodeHTML(formData.websiteTitle),
    tagline: encodeHTML(formData.tagline),
    siteDescription: encodeHTML(formData.siteDescription),
    copyRightContent: encodeHTML(formData.copyRightContent),
    ...formDataToSend
  };

  const sanitizeGoogleVerificationInput = (value) => {
    const sanitizedValue = value.replace(/[^a-zA-Z0-9-_.]/g, '');
    if (/^[0-9.]/.test(sanitizedValue)) {
      return sanitizedValue.slice(1);
    }
    return sanitizedValue.substring(0, 43);

  };

  const handleSubAccordionChange = (index) => {
    setSubExpandedAccordion(subexpandedAccordion === index ? null : index);
  };

  const handleTopNavAccordionChange = (index) => {
    setSubExpandedTopNavAccordion(subexpandedTopNavAccordion === index ? null : index);
  };

  const handleStaticPagesChange = (e) => {
    const val = e.target.value;
    const index = e.target.getAttribute("index");
    let staticPageArray = formData?.staticPages;
    const label = e.target.getAttribute("label");
    if (label === 'static name') {
      staticPageArray[index].name = val;
    } else if (label === 'static source path') {
      staticPageArray[index].sourcePath = val;
    } else if (label === 'static destination path') {
      const numericVal = val.replace(/\D/g, '');
      staticPageArray[index].destinationPath = '/staticpage/' + numericVal + '.html';
    }
    staticPageArray[index].update = true;
    setFormData((prevData) => ({
      ...prevData,
      staticPages: staticPageArray,
    }));
  }

  const handleTopNavigationChange = (e) => {
    const val = e.target.value;
    const index = e.target.getAttribute("index");
    let topNavArray = formData?.topNavigationBar || [];
    const label = e.target.getAttribute("label");
    if (label === 'display name') {
      topNavArray[index].name = val;
    } else if (label === 'url') {
      topNavArray[index].url = val;
    }
    topNavArray[index].update = true;
    setFormData((prevData) => ({
      ...prevData,
      topNavigationBar: topNavArray,
    }));
  }

  const handleBlur = (e) => {
    const val = e.target.value;
    const index = e.target.getAttribute("index");
    let staticPageArray = formData?.staticPages;
    const label = e.target.getAttribute("label");

    if (label === 'static destination path') {
      // Allow only numeric characters
      const numericVal = val.replace(/\D/g, '');
      const name = staticPageArray[index].name;
      validateMsid(name, numericVal);
    }
  };

  const handleAddStaticPage = () => {
    const staticPageArray = formData?.staticPages;
    staticPageArray?.push({ name: 'New Static Page', sourcePath: '', destinationPath: '' })
    setFormData((prevData) => ({
      ...prevData,
      staticPages: staticPageArray,
    }));
  }

  const deleteStaticPage = (subItem, subIndex) => {
    formData?.staticPages?.splice(subIndex, 1);
    const staticPageArray = formData?.staticPages;
    setFormData((prevData) => ({
      ...prevData,
      staticPages: staticPageArray,
    }));
  }

  const handleAddTopNavigationItem = () => {
    const topNavArray = formData?.topNavigationBar || [];
    topNavArray.push({ name: 'New Navigation Item', url: '' });
    setFormData((prevData) => ({
      ...prevData,
      topNavigationBar: topNavArray,
    }));
  }

  const deleteTopNavigationItem = (subItem, subIndex) => {
    formData?.topNavigationBar?.splice(subIndex, 1);
    const topNavArray = formData?.topNavigationBar;
    setFormData((prevData) => ({
      ...prevData,
      topNavigationBar: topNavArray,
    }));
  }

  return (
    <div>
      <Accordion expanded={expanded[0]} onChange={handleChange('panel1')}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel-headerNbody" id="panel-headerNbody">
          <Typography>HEADER & BODY SCRIPTS</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Header Scripts</b>
          </Typography>
          <TextField
            InputProps={{
              rows: 2,
              multiline: true,
              inputComponent: 'textarea',
            }}
            variant="outlined"
            fullWidth
            id="global-header-script"
            style={{ marginBottom: '8px' }}
            value={formData.headerScript || []}
            onChange={(e) => handleScriptChange('headerScript', e.target.value)}
          />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Body Scripts</b>
          </Typography>
          <TextField
            InputProps={{
              rows: 2,
              multiline: true,
              inputComponent: 'textarea',
            }}
            variant="outlined"
            fullWidth
            id="global-body-script"
            value={formData.bodyScript || ''}
            onChange={(e) => handleScriptChange('bodyScript', e.target.value)} />
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded[1]} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel-amp-configuration"
          id="panel-amp-configuration"
        >
          <Typography variant="h6" style={{ display: 'flex' }}>
            WEBSTORY CONFIGURATION
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {/* <FormControlLabel
            style={{
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              marginLeft: '0px',
            }}
            checked={formData.webStoryAds}
            control={<Switch color="primary" style={{ marginRight: '-100px' }} />}
            onChange={(e) => handleInputChange('webStoryAds', e.target.checked)}
            label={<Typography variant="h6" style={{ fontWeight: 'bold' }}>Webstory Ads</Typography>}
            labelPlacement="start"
          /> */}
          {/* <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Header Script</b>
          </Typography>
          <TextField
            InputProps={{
              rows: 2,
              multiline: true,
              inputComponent: 'textarea',
            }}
            variant="outlined"
            fullWidth
            id="amp-header-script"
            style={{ marginBottom: '8px' }}
            value={formData.ampHeaderScript || []}
            onChange={(e) => handleInputChange('ampHeaderScript', e.target.value)}
          /> */}

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Webstory Ad Type</b>
          </Typography>
          <FormControl variant="outlined" fullWidth style={{ marginBottom: '8px' }}>
            <Select
              labelId="amp-header-script"
              id="amp-header-script"
              style={{ textAlign: 'left' }}
              value={formData.ampHeaderScript || 'none'}
              onChange={(e) => handleInputChange('ampHeaderScript', e.target.value)}
              displayEmpty
            >
              <MenuItem value="google">Google Ad</MenuItem>
              <MenuItem value="mgid">MGID Ad</MenuItem>
              <MenuItem value="none">None</MenuItem>
            </Select>
          </FormControl>


          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Data Slot ID</b>
          </Typography>
          <TextField
            InputProps={{
              rows: 2,
              multiline: true,
              inputComponent: 'textarea',
            }}
            variant="outlined"
            fullWidth
            id="amp-body-script"
            value={formData.adsSlots || ''}
            onChange={(e) => handleInputChange('adsSlots', e.target.value)}
            style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Webstory Logo*</b>
          </Typography>
          <TextField value={formData.webstoryLogo || ''} onChange={(e) => handleInputChange('webstoryLogo', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Default Author*</b>
          </Typography>
          <TextField value={formData.webstoryDefaultAuthor || ''} onChange={(e) => handleInputChange('webstoryDefaultAuthor', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Default Agency Name*</b>
          </Typography>
          <TextField value={formData.webstoryDefaultAgencyName || ''} onChange={(e) => handleInputChange('webstoryDefaultAgencyName', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>GA ID</b>
          </Typography>
          <TextField value={formData.gaId || ''} onChange={(e) => handleInputChange('gaId', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>GA4 ID</b>
          </Typography>
          <TextField value={formData.ga4Id || ''} onChange={(e) => handleInputChange('ga4Id', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>CTA Description*</b>
          </Typography>
          <TextField value={formData.ctaDesc || ''} onChange={(e) => handleInputChange('ctaDesc', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>CTA BG Color</b>
          </Typography>
          <ColorPicker value={formData.ctaBgColor || ''} onChange={(colorResult) => handleColorInputChange('ctaBgColor', colorResult)} fullWidth />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>CTA Text*</b>
          </Typography>
          <TextField value={formData.ctaBtnText || ''} onChange={(e) => handleInputChange('ctaBtnText', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>CTA Text Color</b>
          </Typography>
          <ColorPicker value={formData.ctnBtnBgColor || ''} onChange={(colorResult) => handleColorInputChange('ctnBtnBgColor', colorResult)} fullWidth />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>CTA NextSlide </b>
          </Typography>
          <FormControl fullWidth>
            <Select
              labelId="nextslide-select-label"
              id="nextslide-select"
              style={{ textAlign: 'left' }}
              value={formData.ctaNextSlide || "Read Next"}
              onChange={(e) => handleInputChange('ctaNextSlide', e.target.value)}
            >
              <MenuItem value={'Read Next'}>Read Next</MenuItem>
              <MenuItem value={'See more stories'}>See more stories</MenuItem>
            </Select>
          </FormControl>

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>CTA Next Slide Message</b>
          </Typography>
          <TextField value={formData.ctaNextSlideMsg || ''} onChange={(e) => handleInputChange('ctaNextSlideMsg', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Custom Slide Position</b>
          </Typography>
          <TextField value={formData.webstoryCustomSlidePosition || ''} onChange={(e) => handleInputChange('webstoryCustomSlidePosition', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Next Slide CTA</b>
          </Typography>
          <TextField value={formData.webstoryNextSlideCta || ''} onChange={(e) => handleInputChange('webstoryNextSlideCta', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />
            
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded[5]} onChange={handleChange('panel6')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel-immersivestory-configuration"
          id="panel-immersivestory-configuration"
        >
          <Typography variant="h6" style={{ display: 'flex' }}>
            IMMERSIVE STORY CONFIGURATION
          </Typography>
        </AccordionSummary>
        <AccordionDetails>

        <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Immersive Story Logo*</b>
          </Typography>
          <TextField value={formData.immStoryLogo || ''} onChange={(e) => handleInputChange('immStoryLogo', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          {/* <Typography variant="h6" style={{ display: 'flex' }}>
            <b>LOGO Height*</b>
          </Typography>
          <TextField value={formData.immStoryLogoHeight || ''} onChange={(e) => handleInputChange('immStoryLogoHeight', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} /> */}

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>GA ID</b>
          </Typography>
          <TextField value={formData.immStoryGaId || ''} onChange={(e) => handleInputChange('immStoryGaId', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>GA4 ID</b>
          </Typography>
          <TextField value={formData.immStoryGa4Id || ''} onChange={(e) => handleInputChange('immStoryGa4Id', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          {/* <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Site URL</b>
          </Typography>
          <TextField value={formData.immStorySiteUrl || ''} onChange={(e) => handleInputChange('immStorySiteUrl', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} /> */}

        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded[2]} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel-site-resources"
          id="panel-site-resources"
        >
          <Typography variant="h6" style={{ display: 'flex' }}>
            SITE RESOURCES
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Site Title*</b>
          </Typography>
          <TextField value={formData.websiteTitle || ''} onChange={(e) => handleInputChange('websiteTitle', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }}
          />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Site Tagline</b>
          </Typography>
          <TextField value={formData.tagline || ''} onChange={(e) => handleInputChange('tagline', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Site Description</b>
          </Typography>
          <TextField value={formData.siteDescription || ''} onChange={(e) => handleInputChange('siteDescription', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Logo*</b>
          </Typography>
          <TextField value={formData.mainLogo || ''} onChange={(e) => handleInputChange('mainLogo', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Default Image*</b>
          </Typography>
          <TextField value={formData.hostImageId || ''} onChange={(e) => handleInputChange('hostImageId', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          {/* <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Favicon*</b>
          </Typography>
          <TextField value={formData.favicon || ''} onChange={(e) => handleInputChange('favicon', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} /> */}

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Fallback Image</b>
          </Typography>
          <TextField value={formData.fallbackImage || ''} onChange={(e) => handleInputChange('fallbackImage', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Schema Logo*</b>
          </Typography>
          <TextField value={formData.schemaLogo || ''} onChange={(e) => handleInputChange('schemaLogo', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Footer Logo</b>
          </Typography>
          <TextField value={formData.footerLogo || ''} onChange={(e) => handleInputChange('footerLogo', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />
          
          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Amp GA ID</b>
          </Typography>
          <TextField value={formData.ampGaId || ''} onChange={(e) => handleInputChange('ampGaId', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Amp GA4 ID</b>
          </Typography>
          <TextField value={formData.ampGa4Id || ''} onChange={(e) => handleInputChange('ampGa4Id', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Ads.txt</b>
          </Typography>
          <TextField
            InputProps={{
              rows: 2,
              multiline: true,
              inputComponent: 'textarea',
            }}
            variant="outlined"
            id="adstxt"
            fullWidth
            style={{ marginBottom: '8px' }}
            value={formData.adsTxtFile || []}
            onChange={(e) => handleInputChange('adsTxtFile', e.target.value)}
          />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>App-ads.txt</b>
          </Typography>
          <TextField
            InputProps={{
              rows: 2,
              multiline: true,
              inputComponent: 'textarea',
            }}
            variant="outlined"
            id="appadstxt"
            fullWidth
            style={{ marginBottom: '8px' }}
            value={formData.appAdsTxtFile || ''}
            onChange={(e) => handleInputChange('appAdsTxtFile', e.target.value)}
          />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Robots.txt</b>
          </Typography>
          <TextField
            InputProps={{
              rows: 2,
              multiline: true,
              inputComponent: 'textarea',
            }}
            variant="outlined"
            id="robotstxt"
            fullWidth
            style={{ marginBottom: '8px' }}
            value={formData.robotsTxt || []}
            onChange={(e) => handleInputChange('robotsTxt', e.target.value)}
          />
          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Copyright Content</b>
          </Typography>
          <TextField value={formData.copyRightContent || ''} onChange={(e) => handleInputChange('copyRightContent', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Contact us</b>
          </Typography>
          <TextField value={formData.contactUs || ''} onChange={(e) => handleInputChange('contactUs', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />
          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Support Email</b>
          </Typography>
          <TextField value={formData.supportEmail || ''} onChange={(e) => handleInputChange('supportEmail', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />
          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Image Agency </b>
          </Typography>
          <FormControl fullWidth>
            <Select
              labelId="agency-select-label"
              id="agency-select"
              style={{ textAlign: 'left' }}
              value={formData.imageAgencyLabel || "Image Credit"}
              onChange={(e) => handleInputChange('imageAgencyLabel', e.target.value)}
            >
              <MenuItem value={'image_credit'}>Image Credit</MenuItem>
              <MenuItem value={'image_source'}>Image Source</MenuItem>
            </Select>
          </FormControl>
          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Display Date</b>
          </Typography>
          <FormControl fullWidth>
            <Select
              labelId="date-select-label"
              id="date-select"
              style={{ textAlign: 'left' }}
              value={formData.displayDate || "published_date"}
              onChange={(e) => handleInputChange('displayDate', e.target.value)}
            >
              <MenuItem value={'publish_date'}>Publish Date</MenuItem>
              <MenuItem value={'update_date'}>Update Date</MenuItem>
            </Select>
          </FormControl>
          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Display Time Zone</b>
          </Typography>
          <FormControl fullWidth>
            <Select
              labelId="display-timezone-select-label"
              id="display-timezone-select"
              style={{ textAlign: 'left' }}
              value={formData.displayTimeZone || DEFAULT_DISPLAY_TIME_ZONE}
              onChange={(e) => handleInputChange('displayTimeZone', e.target.value)}
            >
              {DISPLAY_TIME_ZONE_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/* Phase 2: Date Format dropdown hidden until the feature goes live.
          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Date Format</b>
          </Typography>
          <FormControl fullWidth>
            <Select
              labelId="display-date-format-select-label"
              id="display-date-format-select"
              style={{ textAlign: 'left' }}
              value={formData.displayDateFormat || DEFAULT_DISPLAY_DATE_FORMAT}
              onChange={(e) => handleThemeConfigChange('displayDateFormat', e.target.value)}
            >
              {DISPLAY_DATE_FORMAT_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {`${option.label} (${option.helperText})`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          */}
          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Site Language*</b>
          </Typography>
          <FormControl fullWidth>
            <Select
              labelId="language-select-label"
              id="language-select"
              style={{ textAlign: 'left' }}
              value={formData.siteLanguage || "Select"}
              onChange={(e) => handleInputChange('siteLanguage', e.target.value)}
            >
              {SITE_LANGUAGES.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Font Family</b>
          </Typography>
          <FormControl fullWidth>
            <Select
              labelId="font-family-select-label"
              id="font-family-select"
              style={{ textAlign: 'left' }}
              value={formData.userSelectedFontFamily || DEFAULT_SITE_FONT.value}
              onChange={(e) => handleInputChange('userSelectedFontFamily', e.target.value)}
            >
              {getFontOptions(formData.siteLanguage, formData.themeId || props.siteResource?.themeId).map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Keywords</b>
          </Typography>
          <TextField value={formData.keywords || ''} onChange={(e) => handleInputChange('keywords', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />
          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>About Site Content</b>
          </Typography>
          <TextField value={formData.aboutSiteContent || ''} onChange={(e) => handleInputChange('aboutSiteContent', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />
          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Theme Color</b>
          </Typography>
          <ColorPicker value={formData.themeColor || ''} onChange={(colorResult) => handleColorInputChange('themeColor', colorResult)} fullWidth />
          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Google Site Verification</b>
          </Typography>
          <TextField value={formData.googleSiteVerification || ''}
            onChange={(e) => {
              const santVal = sanitizeGoogleVerificationInput(e.target.value);
              handleInputChange('googleSiteVerification', santVal);
            }}
            variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <FormControlLabel
            style={{
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              marginLeft: '0px',
            }}
            checked={!!formData.coreWebVitalsAnalytics}
            control={<Switch color="primary" style={{ marginRight: '-100px' }} />}
            onChange={(e) => handleInputChange('coreWebVitalsAnalytics', e.target.checked)}
            label={<Typography variant="h6" style={{ fontWeight: 'bold' }}>Core Web Vitals Analytics</Typography>}
            labelPlacement="start"
          />

        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded[3]} onChange={handleChange('panel4')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel-social-links"
          id="panel-social-links"
        >
          <Typography variant="h6" style={{ display: 'flex' }}>
            SOCIAL LINKS
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>WhatsApp</b>
          </Typography>
          <TextField value={formData.whatsapp || ''} onChange={(e) => handleUrlChange('whatsapp', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Facebook</b>
          </Typography>
          <TextField value={formData.facebook || ''} onChange={(e) => handleUrlChange('facebook', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />


          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>X (Formally Twitter)</b>
          </Typography>
          <TextField value={formData.twitter || ''} onChange={(e) => handleUrlChange('twitter', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Youtube</b>
          </Typography>
          <TextField value={formData.youtube || ''} onChange={(e) => handleUrlChange('youtube', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>LinkedIn</b>
          </Typography>
          <TextField value={formData.linkedIn || ''} onChange={(e) => handleUrlChange('linkedIn', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Instagram</b>
          </Typography>
          <TextField value={formData.instagram || ''} onChange={(e) => handleUrlChange('instagram', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Pinterest</b>
          </Typography>
          <TextField value={formData.pinterest || ''} onChange={(e) => handleUrlChange('pinterest', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />

          <Typography variant="h6" style={{ display: 'flex' }}>
            <b>Playstore</b>
          </Typography>
          <TextField value={formData.playstore || ''} onChange={(e) => handleUrlChange('playstore', e.target.value)} variant="outlined" fullWidth style={{ marginBottom: '8px' }} />
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded[4]} onChange={handleChange('panel5')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel-social-links"
          id="panel-social-links"
        >
          <Typography variant="h6" style={{ display: 'flex' }}>
            STATIC PAGES
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {formData.staticPages && formData.staticPages.map((subItem, subIndex) => (
            <div style={{ border: '1px solid #cccccc' }}>
              <Accordion key={subIndex} expanded={subexpandedAccordion === subIndex} onChange={() => handleSubAccordionChange(subIndex)}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography>{subItem.name}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <div>
                    <Typography variant="h6" align="left">Display Name:</Typography>
                    <div>
                      <input type="text" className='inputBoxStyle' label="static name" index={subIndex} value={subItem?.name} maxLength={100} onChange={(e) => handleStaticPagesChange(e)} />
                    </div>
                    <Typography variant="h6" align="left">Short URL:</Typography>
                    <div>
                      <input type="text" className='inputBoxStyle' label="static source path" index={subIndex} value={subItem?.sourcePath} maxLength={100} onChange={(e) => handleStaticPagesChange(e)} />
                    </div>
                    <Typography variant="h6" align="left">MSID of the static article:</Typography>
                    <div>
                      <input type="number" className='inputBoxStyleNumber' label="static destination path" index={subIndex} value={subItem?.destinationPath?.match(/\d+/g)?.join('')} maxLength={100} onBlur={(e) => handleBlur(e)} onChange={(e) => handleStaticPagesChange(e)} onWheel={(e) => e.target.blur()} />
                    </div>
                    <div className='deleteIcon1'>
                      {/* <i className="fas fa-trash-alt" onClick={() => deleteStaticPage(subItem, subIndex)}></i> */}
                    <FontAwesomeIcon icon={faTrash} onClick={() => deleteStaticPage(subItem, subIndex)} />
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
          ))}
          <div style={{ textAlign: 'right' }}>
            <Button variant="contained" onClick={() => handleAddStaticPage()} size="small" style={{ minWidth: '80px', minHeight: '24px', fontSize: '0.55rem', marginTop: '10px' }}>+ Add Static Page</Button>
          </div>
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded[6]} onChange={handleChange('panel7')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel-top-navigation"
          id="panel-top-navigation"
        >
          <Typography variant="h6" style={{ display: 'flex' }}>
            TOP NAVIGATION BAR
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {formData.topNavigationBar && formData.topNavigationBar.map((subItem, subIndex) => (
            <div style={{ border: '1px solid #cccccc' }}>
              <Accordion key={subIndex} expanded={subexpandedTopNavAccordion === subIndex} onChange={() => handleTopNavAccordionChange(subIndex)}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography>{subItem.name}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <div>
                    <Typography variant="h6" align="left">Display Name:</Typography>
                    <div>
                      <input type="text" className='inputBoxStyle' label="display name" index={subIndex} value={subItem?.name} maxLength={100} onChange={(e) => handleTopNavigationChange(e)} />
                    </div>
                    <Typography variant="h6" align="left">URL:</Typography>
                    <div>
                      <input type="text" className='inputBoxStyle' label="url" index={subIndex} value={subItem?.url} maxLength={500} onChange={(e) => handleTopNavigationChange(e)} />
                    </div>
                    <div className='deleteIcon1'>
                      <FontAwesomeIcon icon={faTrash} onClick={() => deleteTopNavigationItem(subItem, subIndex)} />
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
          ))}
          <div style={{ textAlign: 'right' }}>
            <Button variant="contained" onClick={() => handleAddTopNavigationItem()} size="small" style={{ minWidth: '80px', minHeight: '24px', fontSize: '0.55rem', marginTop: '10px' }}>+ Add Navigation Item</Button>
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded[7]} onChange={handleChange('panel8')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel-google-authentication"
          id="panel-google-authentication"
        >
          <Typography variant="h6" style={{ display: 'flex' }}>
            GOOGLE AUTHENTICATION
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormControlLabel
            style={{
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              marginLeft: '0px',
            }}
            checked={!!formData.enableGoogleLogin}
            control={<Switch color="primary" style={{ marginRight: '-100px' }} />}
            onChange={(e) => handleInputChange('enableGoogleLogin', e.target.checked)}

            // onChange={(e) => {
            //   const isEnabled = e.target.checked;
            //   handleInputChange('enableGoogleLogin', isEnabled);
            //   if (!isEnabled) {
            //     handleInputChange('googleClientId', '');
            //     handleInputChange('googleClientSecret', '');
            //   }
            // }}

            label={<Typography variant="h6" style={{ fontWeight: 'bold' }}>Enable Google Login</Typography>}
            labelPlacement="start"
          />
          {formData.enableGoogleLogin && (
            <>
              <Typography variant="h6" style={{ display: 'flex', marginTop: '8px' }}>
                <b>Google Client ID</b>
              </Typography>
              <TextField
                value={formData.googleClientId || ''}
                onChange={(e) => handleInputChange('googleClientId', e.target.value)}
                variant="outlined"
                fullWidth
                style={{ marginBottom: '8px' }}
              />
              <Typography variant="h6" style={{ display: 'flex' }}>
                <b>Google Client Secret</b>
              </Typography>
              <TextField
                value={formData.googleClientSecret || ''}
                onChange={(e) => handleInputChange('googleClientSecret', e.target.value)}
                variant="outlined"
                fullWidth
                style={{ marginBottom: '8px' }}
              />
            </>
          )}
        </AccordionDetails>
      </Accordion>
      <Button style={{ marginTop: '20px' }} variant="outlined" onClick={handleButtonClick} {...(isSaving && { disabled: true })}>Save/Update</Button>
    </div>
  );
}


export default GlobalSettingComponent;
